import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

export interface LegalExpDeteminationFormGroup {
  sixtyKor100kYearlyPortfolio: FormControl<boolean>;
  yearinLeadLeadRoleWhere2mNetIncomeOrProf: FormControl<boolean>;
  hasSignificantMarketActivityFor4QuarterTenTransaction: FormControl<boolean>;
  validStatements: FormControl<boolean>;
}

export function getLegalExpDeteminationFormGroup(
  fb: FormBuilder,
): FormGroup<LegalExpDeteminationFormGroup> {
  return fb.nonNullable.group({
    sixtyKor100kYearlyPortfolio: fb.nonNullable.control(false),
    yearinLeadLeadRoleWhere2mNetIncomeOrProf: fb.nonNullable.control(false),
    hasSignificantMarketActivityFor4QuarterTenTransaction:
      fb.nonNullable.control(false),
    validStatements: fb.nonNullable.control(false, Validators.requiredTrue),
  });
}
